import api from '@/api/api'
import { schema } from 'normalizr'
import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index'

const incidencias = new schema.Entity('incidencias')
export const ambito = new schema.Entity('ambito', {
  incidencias: [incidencias]
})

export const CancelToken = axios.CancelToken;

export default {
  codigoTipoSolicitudes: '',
  namespaced: true,
  state: {
    tieneAcceso: null,
    newIncidenceId: null,
    imagesToUp: {},
    listaIncidencias: [],
    datosIncidencia: [],
    localizaciones: [],
    urgencias: [],
    oficios: [],
    suboficios: [],
    estados: [],
    userPromociones: [],
    promociones: [],
    tipoVisita: [],
    incidenciasPred: [],
    providers: [],
    responsables: [],
    complaintTypes: [],
    orderTypes: [],
    annotations: [],
    specialPropTypes: [],
    selectectPromoId: null,
    inmueblesEspeciales: [],
    clientesEspeciales: [],
    clientesEspPorPromo: [],
    clientesEspPorIdPromo: [],
    predefIncidences: [],
    propertyTypes: [],
    providersByProf: [],
    predefInciByProf: [],
    roomPropTypes: [],
    propertiesByStringAndPropDevId: [],
    inmueblesEspecialesByStringAndIdPromocion: [],
    lastLogIncidence: [],
    historyStatus: [],
    tiposParte: [],
    tiposInmueble: [],
    aperturaPictures: [],
    cierrePictures: [],
    cierreFirmaPictures: [],
    documentPictures: [],
    documentPicturesVisit: [],
    documentosResumen: [],
    singleDoc: [],
    incidenciasByVisita: [],
    actualVisit: null,
    actualVisitId: null,
    complaintByIncidence: [],
    providersByPropDevAndProf: [],
    locationSelected: [],
    providersByString: [],
    // hasRelations: false,
    imgFirma: [],
    mensajesEstados: [],
    clientes: [],
    clientesPorPromocionInmueble:[],
    filtros: {
      responsable: [],
      selectedPropertyDesc: null,
      propertyDevelopment: [],
      selectedProperties: [],
      selectedProperty: {
        promocionId: null,
        inmuebleId: null,
        inmuebleEspecialId: null,
        uhedit: null,
        cliente: null,
        direccion: null
      },
      location: [],
      status: [],
      profession: [],
      subprofession: [],
      predefinedIncidence: [],
      provider: [],
      orderType: [],
      vb: false,
      complaint: null,
      idIncidence: null,
      openDate1: null,
      openDate2: null,
      finishDate1: null,
      finishDate2: null,
      realFinishDate1: null,
      realFinishDate2: null,
      notificationDate1: null,
      notificationDate2: null,
      closeDate1: null,
      closeDate2: null,
      visitFecha: null,
      numVisit: null,
      origen: [],
      nombreCliente: null,
      telefono: null,
      movil: null,
      email: null,
      tipoVisita: [],
      codigoTipoSolicitud: [],
      severityId: [],
      openDate: [],
      finishDate: [],
      realFinishDate: [],
      notificationDate: [],
      closeDate: [],
      lastPage: 1,
      navCodTipoSolicitud: 0,
      revisada: false,
      fechaRevisada: [],
      valorCP: null,
      clientDate: [],
      numRegistro: null
    },
    idVisitaCliente: null,
    sourceGetDocuments: null,
    sourceGetSmallPicturesFirma: null,
    sourceGetSmallPicturesApertura: null,
    sourceGetSmallPicturesCierre: null,
    sourceGetSmallPicturesCierreFirma: null,
    filtrosCliente: {
      idIncidence: '',
      codigoTipoSolicitud: '',
      codigoTipoSolicitudes: '',
      status: '',
      propertyDevelopment: null,
      selectedPropertyDesc: '',
      selectedProperty: {
        promocionId: '',
        inmuebleId: '',
        inmuebleEspecialId: '',
        uhedit: '',
        cliente: '',
        direccion: ''
      },
      severityId: ''
    },
    visitaModificada: false,
    mostrarModalAntesDeSalir: false,
    translates: [],
    estadosFiltroInicial: [],
    pendingMessages: []
  },
  mutations: {
    setTieneAcceso (state, payload) {
      state.tieneAcceso = payload
    },
    setImagesToUp (state, payload) {
      state.imagesToUp = payload
    },
    setNewIncidenceId (state, payload) {
      state.newIncidenceId = payload
    },
    setNavCodTipoSolicitud (state, payload) {
      state.navCodTipoSolicitud = payload
    },
    setLastPageVisited (state, payload) {
      state.lastPage = payload
    },
    setCodigoTipoSolicitudes (state, payload) {
      state.codigoTipoSolicitudes = payload
    },
    setFiltros (state, payload) {
      state.filtros = payload
    },
    setFiltrosCliente (state, payload) {
      state.filtrosCliente = payload
    },
    setImgFirma (state, payload) {
      state.imgFirma = payload
    },
    setProvidersByString (state, payload) {
      state.providersByString = payload
    },
    // setHasRelations (state, payload) {
    //   state.hasRelations = payload
    // },
    setLocationSelected (state, payload) {
      state.locationSelected = payload
    },
    setProvidersByPropDevAndProf (state, payload) {
      state.providersByPropDevAndProf = payload
    },
    setComplaintTypesByIncidence (state, payload) {
      state.complaintByIncidence = payload
    },
    setSingleDoc (state, payload) {
      state.singleDoc = payload
    },
    setAperturaPictures (state, payload) {
      state.aperturaPictures = payload
    },
    setCierrePictures (state, payload) {
      state.cierrePictures = payload
    },
    setCierrePicturesFirma (state, payload) {
      state.cierreFirmaPictures = payload
    },
    setDocumentosResumen (state, payload) {
      state.documentosResumen = payload
    },
    setDocumentPictures (state, payload) {
      state.documentPictures = payload
    },
    setDocumentPicturesVisit (state, payload) {
      state.documentPicturesVisit = payload
    },
    setHistoryStatus (state, payload) {
      state.historyStatus = payload
    },
    setLastLogIncidence (state, payload) {
      state.lastLogIncidence = payload
    },
    setInmueblesEspecialesByStringAndIdPromocion (state, payload) {
      state.inmueblesEspecialesByStringAndIdPromocion = payload
    },
    setPropertiesByStringAndPropDevId (state, payload) {
      state.propertiesByStringAndPropDevId = payload
    },
    setAllRoomPropTypes (state, payload) {
      state.roomPropTypes = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setProvidersByProf (state, payload) {
      state.providersByProf = payload.map((key) => {
        let translates
        if(key.professionTranslates){ 
          translates = JSON.parse(key.professionTranslates)
        } else {
          translates = {}
        }
        translates['spa'] = key.profession;
        return {
          ...key, professionTranslates: translates
        }
      })
    },
    setPropertyTypes (state, payload) {
      state.propertyTypes = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setPredefinedIncidences (state, payload) {
      state.predefIncidences = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key,
          translates: translates
        }
      })
    },
    setPredefInciByProf (state, payload) {
      state.predefInciByProf = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setClientesEspByPromo (state, payload) {
      state.clientesEspPorPromo = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setClientesEspecialesPorIdPromocion (state, payload) {
      state.clientesEspPorIdPromo = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setClientesEspeciales (state, payload) {
      state.clientesEspeciales = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setInmueblesEspecialesByPromo (state, payload) {
      state.inmueblesEspeciales = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key,
          translates: translates
        }
      })
    },
    setSelectedPromoId (state, payload) {
      state.selectectPromoId = payload
    },
    setSpecialPropertyTypes (state, payload) {
      state.specialPropTypes = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key,
          translates: translates
        }
      })
    },
    setAnnotations (state, payload) {
      state.annotations = payload
    },
    setOrderTypes (state, payload) {
      state.orderTypes = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key,
          translates: translates
        }
      })
    },
    setResponsables (state, payload) {
      state.responsables = payload
    },
    setComplaintTypes (state, payload) {
      state.complaintTypes = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setProviders (state, payload) {
      state.providers = payload
    },
    setIncidenciasPred (state, payload) {
      state.incidenciasPred = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setSuboficios (state, payload) {
      state.suboficios = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setPromociones (state, payload) {
      state.promociones = payload
    },
    setEstados (state, payload) {
      state.estados = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setEstadosFiltroInicial(state, payload) {
      state.estadosFiltroInicial = payload
    },
    setVisitTypes (state, payload) {
      state.tipoVisita = payload
    },
    setAllIncidences (state, payload) {
      state.listaIncidencias = []
      state.listaIncidencias = payload
    },
    setIncidencia (state, payload) {
      state.datosIncidencia = payload
    },
    setIncidenciasByVisita (state, payload) {
      state.incidenciasByVisita = payload
    },
    setLocalizaciones (state, payload) {
      state.localizaciones = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    setUrgencias (state, payload) {
      state.urgencias = payload
    },
    setOficios (state, payload) {
      state.oficios = payload.map((key) => {
        let translates
        if(key.translates){ 
          translates = JSON.parse(key.translates)
        } else {
          translates = {}
        }
        translates['spa'] = key.name;
        return {
          ...key, translates: translates
        }
      })
    },
    delete (state, id) {
      Vue.delete(state.ambitos, id)
    },
    setTiposParte (state, payload) {
      state.tiposParte = payload.data
    },
    setTiposInmueble (state, payload) {
      state.tiposInmueble = payload.data
    },
    setActualVisit (state, payload) {
      state.actualVisit = payload
    },
    setActualVisitId (state, payload) {
      state.actualVisitId = payload
    },
    setMensajesEstados (state, payload) {
      state.mensajesEstados = payload
    },
    setCustomers (state, payload) {
      state.clientes = payload
    },
    setClientesPorPromocionInmueble(state, payload) {
      state.clientesPorPromocionInmueble = payload
    },
    setIdVisitaCliente (state, payload) {
      state.idVisitaCliente = payload
    },
    setSourceGetDocuments (state, payload) {
      state.sourceGetDocuments = payload
    },
    setSourceGetSmallPicturesFirma (state, payload) {
      state.sourceGetSmallPicturesFirma = payload
    },
    setSourceGetSmallPicturesApertura (state, payload) {
      state.sourceGetSmallPicturesApertura = payload
    },
    setSourceGetSmallPicturesCierre (state, payload) {
      state.sourceGetSmallPicturesCierre = payload
    },
    setSourceGetSmallPicturesCierreFirma (state, payload) {
      state.sourceGetSmallPicturesCierreFirma = payload
    },
    setVisitaModificada (state, payload) {
      state.visitaModificada = payload
    },
    setMostrarModalAntesDeSalir (state, payload) {
      state.mostrarModalAntesDeSalir = payload
    },
    setTranslates (state, payload) {
      state.translates = payload
    },
    setPendingMessages(state, payload) {
      state.pendingMessages = payload
    }
  },
  actions: {
    mostrarPopupConfirmar ({ commit }) {
      commit('setMostrarModalAntesDeSalir', true)
    },
    ocultarPopupConfirmar  ({ commit }) {
      commit('setMostrarModalAntesDeSalir', false)
    },
    cambiarVisitaModificada({ commit, state }) {
      const valorActual = state.visitaModificada;
      commit('setVisitaModificada', !valorActual)
    },
    getIncidencias ({ commit, rootState, dispatch }, filtros) {
      const idubapi = rootState.login.idubapi
      let promociones = {}
      if (rootState.login.rolCliente === true) {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones.map(e => {
            return e.code
          })
        }
      } else {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
      }
      let rolProveedorEstados = false
      if(rootState.login.rolProveedor){
        if(idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === "1" || idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === 1){
          rolProveedorEstados = true
        }
      }
      
      var objetoFiltros = {
        codigoTipoSolicitud: [],
        propertyDevelopment: [],
        selectedProperties: [],
        selectedProperty: {
          promocionId: null,
          inmuebleId: null,
          inmuebleEspecialId: null,
          uhedit: '',
          cliente: '',
          direccion: '',
          operationId: rootState.login.rolCliente === true ? 123 : null,
        },
        location: [],
        status: [],
        profession: [],
        subprofession: [],
        predefinedIncidence: [],
        provider: [],
        orderType: [],
        vb: 0,
        complaint: [],
        idIncidence: '',
        openDate1: null,
        openDate2: null,
        finishDate1: null,
        finishDate2: null,
        realFinishDate1: null,
        realFinishDate2: null,
        notificationDate1: null,
        notificationDate2: null,
        closeDate1: null,
        closeDate2: null,
        visitFecha: null,
        numVisit: '',
        origen: [],
        nombreCliente: '',
        telefono: '',
        movil: '',
        email: '',
        evaluada: '',
        tipoVisita: [],
        filtroSesion: false,
        // promociones: state.promociones
        promociones: promociones,
        rolCliente: rootState.login.rolCliente === true ? true : false,
        rolProveedor: rootState.login.rolProveedor === true ? true : false,
        rolProveedorEstados: rolProveedorEstados || false,
        valorCP: null,
        tiposDeVisita: idubapi.PERMISOS_ACTOR_VISITAS_PV || null
      }
      if (filtros !== undefined) {
        Object.assign(objetoFiltros, filtros)
        if (Array.isArray(objetoFiltros.tipoVisita)) {
          if (objetoFiltros.tipoVisita.length > 1) {
            objetoFiltros.tipoVisita = objetoFiltros.tipoVisita.join('|')
          } else {
            objetoFiltros.tipoVisita = objetoFiltros.tipoVisita[0]
          }
        }
      }
      return new Promise((resolve, reject) => {
        api.post('/incidence/getIncidences', {
          credentials: rootState.login.credentials,
          values: Object.assign({}, objetoFiltros, {tiposSolicitudesDisponibles: rootState.login.idubapi.tiposSolicitudes})
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            // 269828 - ARN - Si da error por el limite de solicitudes mostramos el error
            if(response.data.result == 'NOK') {
              dispatch('alerts/add', { texto: response.data.descriptionNOK, color: 'error'}, {root:true})
              resolve()
            } else {
              // console.log('response getallINCIDENCES: ', response.data.data)
              // commit('setAllIncidences', [])
              commit('setAllIncidences', response.data.data)
              resolve()
            }

          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getIncidenciasFiltradas ({ commit, rootState, dispatch }, filtros) {
      // TODO pasar los parametros dependiendo de los filtros
      const idubapi = rootState.login.idubapi
      const promociones = {
        [idubapi.idubapi]: idubapi.promociones
      }

      filtros.promociones = promociones
      filtros.tiposDeVisita = idubapi.PERMISOS_ACTOR_VISITAS_PV || null

      api.post('/incidence/getIncidences', {
        credentials: rootState.login.credentials,
        values: filtros
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          // console.log('response getallINCIDENCES: ', response.data.data)
          // commit('setAllIncidences', [])
          commit('setAllIncidences', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    getIncidenciasByVisita ({ commit, rootState, dispatch }, visitId) {
      return new Promise((resolve, reject) => {
        api.post('/incidence/getIncidenceFromListNumber', {
          credentials: rootState.login.credentials,
          values: {
            visitId: visitId
          }
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setIncidenciasByVisita', response.data.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getIncidencia ({ commit, rootState, dispatch }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/incidence/getIncidenceById', {
          credentials: rootState.login.credentials,
          values: {
            incidenceId: objeto
          }
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setIncidencia', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    delIncidencias ({ rootState }, itemIds) {
      return new Promise((resolve, reject) => {
        api.post('incidence/delIncidences', {
          credentials: rootState.login.credentials,
          values: itemIds
        })
          .then(() => {
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateIncidencia ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('incidence/updateIncidence', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getStatusTypes ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('incidence/getStatusTypes', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setEstados', response.data)
            let estadosFiltroInicial = response.data.filter(item => item.code !== '50' && item.code !== '90')

            commit('setEstadosFiltroInicial', estadosFiltroInicial.map(item => item.id))

            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getVisitTypes ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('varios/getVisitTypes', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setVisitTypes', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getPropertiesDevelopment ({ commit, rootState, dispatch }) {
      const idubapi = rootState.login.idubapi
      const promociones = {
        [idubapi.idubapi]: idubapi.promociones
      }

      let urlApi = 'propertyDevelopment/getPropertiesDevelopment'
      if (rootState.login.rolProveedor) {
        urlApi = 'incidence/obtenerPromocionesProveedor'
      }
      
      return new Promise((resolve, reject) => {
        api.post(urlApi, {
          credentials: rootState.login.credentials,
          promociones: promociones
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            let promociones = response.data.data.sort(function(a, b) {
              return a.code.localeCompare(b.code, undefined, {
                numeric: true,
                sensitivity: 'base'
              });
            });
            commit('setPromociones', promociones)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getLocalizaciones ({ commit, rootState, dispatch }, tipoInmueble) {
      return new Promise((resolve, reject) => {
        api.post('roomPropertyType/getRoomPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            propertyTypeId: tipoInmueble
          }
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setLocalizaciones', response.data.data)
          resolve()
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getUrgencias ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('/varios/getTiposUrgencia', {
          credentials: rootState.login.credentials,
          values: {}
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setUrgencias', response.data.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getOficios ({ commit, rootState, dispatch }, params) {
      return new Promise((resolve, reject) => {
        api.post('profession/getProfessions', {
          credentials: rootState.login.credentials,
          values: {
            providerId: (params && params.providerId) ? params.providerId : null,
            promotionId: (params && params.promotionId) ? params.promotionId : null
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setOficios', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    addNewOficio ({ rootState, dispatch }, newOficio) {
      return new Promise((resolve, reject) => {
        api.post('profession/AddProfessions', {
          credentials: rootState.login.credentials,
          values: {
            code: newOficio.code,
            name: newOficio.name,
            idioma: newOficio.idioma,
            tipoMaestro: newOficio.tipoMaestro
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateOficio ({ rootState, dispatch }, oficio) {
      return new Promise((resolve, reject) => {
        api.post('profession/updateProfessions', {
          credentials: rootState.login.credentials,
          values: {
            id: oficio.id,
            code: oficio.code,
            name: oficio.name,
            idioma: oficio.idioma,
            tipoMaestro: oficio.tipoMaestro
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteOficio ({ rootState, dispatch }, oficioId) {
      return new Promise((resolve, reject) => {
        api.post('profession/delProfessions', {
          credentials: rootState.login.credentials,
          values: {
            id: oficioId
          }
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarOficioAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('profession/comprobarOficioAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getTranslates ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('translate/getTranslatesMaestro', {
          credentials: rootState.login.credentials,
          values,
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setTranslates', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateTranslates ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('translate/updateTranslatesMaestro', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getSuboficios ({ commit, rootState, dispatch }, oficioId) {
      return new Promise((resolve, reject) => {
        api.post('subProfession/getSubProfessions', {
          credentials: rootState.login.credentials,
          values: {
            professionId: oficioId
          }
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          commit('setSuboficios', response.data.data)
          resolve()
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    addSuboficio ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('subProfession/addSubProfessions', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateSuboficio ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('subProfession/updateSubProfessions', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    comprobarSubOficioAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('subProfession/comprobarSubOficioAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteSuboficio ({ rootState, dispatch }, subOficioId) {
      return new Promise((resolve, reject) => {
        api.post('subProfession/delSubProfessions', {
          credentials: rootState.login.credentials,
          values: {
            id: subOficioId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            // console.log('DATA RESULT OK', response)
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getProviders ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('provider/getProviders', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setProviders', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getProvidersByPropertyDevAndProfession ({ commit, rootState, dispatch }, item) {
      return new Promise((resolve, reject) => {
        api.post('provider/getProvidersByPropertyDevAndProfession', {
          credentials: rootState.login.credentials,
          values: {
            actor: true,
            professionId: item.professionId,
            propertyDevelopmentId: item.propertyDevelopmentId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setProvidersByPropDevAndProf', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getProvidersByProffesion ({ commit, rootState, dispatch }, stringBusqueda) {
      const idubapi = rootState.login.idubapi
      let promociones = {}
      if (rootState.login.rolCliente === true) {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones.map(e => {
            return e.code
          })
        }
      } else {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
      }
      api.post('providerByProffesion/getProvidersByProffesion', {
        credentials: rootState.login.credentials,
        values: {
          providerString: stringBusqueda,
          promociones: promociones
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setProvidersByProf', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    checkProvidersByProffesion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('providerByProffesion/checkProvidersByProffesion', {
          credentials: rootState.login.credentials,
          values: {
            oficiosSelected: values.proffesion,
            promocionesSelected: values.propertyDevelopment,
            proveedorSelected: values.provider
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
            }
            resolve(response.data.data)
          })
          .catch(e => {
            return e
          })
      })
    },
    addProviderByProffesion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('providerByProffesion/addProviderByProffesion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject(response.data)
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateProviderByProffesion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('providerByProffesion/updateProviderByProffesion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject(response.data)
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    comprobarProviderByProffesionAsignado ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('providerByProffesion/comprobarProviderByProffesionAsignado', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getProvidersByString ({ commit, rootState, dispatch }, stringBusqueda) {
      return new Promise((resolve, reject) => {
        api.post('provider/getProvidersByString', {
          credentials: rootState.login.credentials,
          values: {
            providerString: stringBusqueda
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setProvidersByString', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateProviders ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('provider/updateProviders', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    crearActorAsociadoRolProveedor ({ rootState }, values) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Postventa/crear_actor_asociado_a_rol_proveedor',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                id_bd_prinex: rootState.login.credentials.idubapi,
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                id_actor: usuarioJson.id,
                cod_app: 10,
                id_modulo: 1,
                id_proveedor: values
              }
            })
          })
        )
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              // eslint-disable-next-line
              reject({
                message: response.data.result.message + response.data.result.message_detail
              })
            }
          })
          .catch(e => {
            return e
          })
      })
    },
    delProviderByProffesion ({ rootState, dispatch }, itemId) {
      api.post('providerByProffesion/delProviderByProffesion', {
        credentials: rootState.login.credentials,
        values: {
          id: itemId
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          return response
        })
        .catch(e => {
          return e
        })
    },
    getResponsables ({ commit, rootState, dispatch }) {
      api.post('varios/getResponsables', {
        credentials: rootState.login.credentials,
        values: {}
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setResponsables', response.data.data)
        })
    },
    getComplaintTypes ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('complaintType/getComplaintTypes', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setComplaintTypes', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    addComplaintType ({ rootState, dispatch }, newComplaintType) {
      return new Promise((resolve, reject) => {
        api.post('complaintType/addComplaintTypes', {
          credentials: rootState.login.credentials,
          values: {
            code: newComplaintType.code,
            name: newComplaintType.name,
            idioma: newComplaintType.idioma,
            tipoMaestro: newComplaintType.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateComplaintType ({ rootState, dispatch }, newComplaintType) {
      return new Promise((resolve, reject) => {
        api.post('complaintType/updateComplaintTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: newComplaintType.id,
            code: newComplaintType.code,
            name: newComplaintType.name,
            idioma: newComplaintType.idioma,
            tipoMaestro: newComplaintType.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarComplaintTypeAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('complaintType/comprobarComplaintTypeAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    delComplaintType ({ rootState, dispatch }, itemId) {
      return new Promise((resolve, reject) => {
        api.post('complaintType/delComplaintTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: itemId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getOrderTypes ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('orderType/getOrderTypes', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setOrderTypes', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    addOrderType ({ rootState, dispatch }, newOrder) {
      return new Promise((resolve, reject) => {
        api.post('orderType/addOrderTypes', {
          credentials: rootState.login.credentials,
          values: {
            code: newOrder.code,
            name: newOrder.name,
            idioma: newOrder.idioma,
            tipoMaestro: newOrder.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateOrderType ({ rootState, dispatch }, newOrder) {
      return new Promise((resolve, reject) => {
        api.post('orderType/updateOrderTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: newOrder.id,
            code: newOrder.code,
            name: newOrder.name,
            idioma: newOrder.idioma,
            tipoMaestro: newOrder.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarOrderTypesAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('orderType/comprobarOrderTypesAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    delOrderType ({ rootState, dispatch }, orderId) {
      return new Promise((resolve, reject) => {
        api.post('orderType/delOrderTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: orderId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getAnnotations ({ commit, rootState, dispatch }, idIncidencia) {
      return new Promise((resolve, reject) => {
        api.post('annotation/getAnnotations', {
          credentials: rootState.login.credentials,
          values: {
            incidenceId: idIncidencia
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setAnnotations', [])
            commit('setAnnotations', response.data)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteAnnotation ({ rootState, dispatch }, { id, incidenceId }) {
      return new Promise((resolve, reject) => {
        api.post('annotation/delAnnotation', {
          credentials: rootState.login.credentials,
          values: {
            id,
            incidenceId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            resolve(response) 
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addAnnotation ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('annotation/addAnnotation', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
        })
    },
    updateAnnotation ({ rootState, dispatch }, values) {
      return new Promise((resolve,reject) => {
        api.post('annotation/updateAnnotation', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            resolve(response) 
          })
          .catch(
            e => {
              reject(e)
            })
      })
    },
    getSpecialPropertyTypes ({ commit, rootState, dispatch }) {
      api.post('specialPropertyType/getSpecialPropertyTypes', {
        credentials: rootState.login.credentials,
        values: {}
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setSpecialPropertyTypes', response.data.data)
        })
        .catch(
          e => {
            return e
          })
    },
    addInmuebleEspecial ({ rootState, dispatch }, newInmueble) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/addSpecialPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            code: newInmueble.code,
            name: newInmueble.name,
            todasLasPromociones: newInmueble.todasLasPromociones,
            idioma: newInmueble.idioma,
            tipoMaestro: newInmueble.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateInmuebleEspecial ({ rootState, dispatch }, newInmueble) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/updateSpecialPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: newInmueble.id,
            code: newInmueble.code,
            name: newInmueble.name,
            todasLasPromociones: newInmueble.todasLasPromociones,
            idioma: newInmueble.idioma,
            tipoMaestro: newInmueble.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarInmuebleEspecialAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/comprobarInmuebleEspecialAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteInmuebleEspecial ({ rootState, dispatch }, itemId) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/delSpecialPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: itemId
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getInmueblesEspecialesByPromo ({ commit, rootState, dispatch }, promoId) {
      let inmueblesCheck = []
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/getInmueblesEspecialesByPromocion', {
          credentials: rootState.login.credentials,
          values: {
            idPromocion: promoId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            inmueblesCheck = response.data.data

            const inmueblesFiltrados = inmueblesCheck.reduce((acc, current) => {
              const x = acc.find(item => item.id === current.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);

            commit('setInmueblesEspecialesByPromo', inmueblesFiltrados)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
        })
    },
    addInmueblesEspecialesByPromo ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/addInmueblesEspecialesByPromocion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    delInmueblesEspecialesByPromocion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialPropertyType/delInmueblesEspecialesByPromocion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getClientesEspeciales ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/getSpecialCustomers', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setClientesEspeciales', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    addClienteEspecial ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/addSpecialCustomers', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateClienteEspecial ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/updateSpecialCustomers', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarClienteEspecialAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/comprobarClienteEspecialAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteClienteEspecial ({ rootState, dispatch }, idCliente) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/delSpecialCustomers', {
          credentials: rootState.login.credentials,
          values: {
            id: idCliente
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getClientesEspecialesPromocionByIdPromocion ({ commit, rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/getClientesEspecialesPromocionByIdPromocion', {
          credentials: rootState.login.credentials,
          values: {
            idPromocion: id
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setClientesEspecialesPorIdPromocion', response.data.data)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getClientesEspecialesByPromo ({ commit, rootState, dispatch }, idPromocion) {
      api.post('specialCustomer/getClientesEspecialesByPromocion', {
        credentials: rootState.login.credentials,
        values: {
          idPromocion: idPromocion
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          const clientes = response.data.data
          clientes.map(e => {
            if (e.idRelacion === null || e.fechaBaja !== null) {
              Object.assign(e, { checked: false })
            } else {
              Object.assign(e, { checked: true })
            }
          })
          commit('setClientesEspByPromo', clientes)
        })
        .catch(e => {
          return e
        })
    },
    addClientesEspByPromo ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/addClientesEspecialesByPromocion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    delClientesEspByPromo ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('specialCustomer/delClientesEspecialesByPromocion', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getPredefinedIncidencesByProfession ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('predefinedIncidence/getPredefinedIncidencesByProfession', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setPredefInciByProf', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getPredefinedIncidences ({ commit, rootState, dispatch }, values) {
      api.post('predefinedIncidence/getPredefinedIncidences', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setPredefinedIncidences', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    delPredefinedIncidences ({ rootState, dispatch }, itemId) {
      return new Promise((resolve, reject) => {
        api.post('predefinedIncidence/delPredefinedIncidences', {
          credentials: rootState.login.credentials,
          values: {
            id: itemId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addPredefinedIncidences ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('predefinedIncidence/addPredefinedIncidences', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updatePredefinedIncidences ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('predefinedIncidence/updatePredefinedIncidences', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarIncidenciaPredefAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('predefinedIncidence/comprobarIncidenciaPredefAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getPropertyTypes ({ commit, rootState, dispatch }) {
      api.post('propertyType/getPropertyTypes', {
        credentials: rootState.login.credentials,
        values: {}
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setPropertyTypes', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    addPropertyType ({ rootState, dispatch }, newOrder) {
      return new Promise((resolve, reject) => {
        api.post('propertyType/addPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            code: newOrder.code,
            name: newOrder.name,
            idioma: newOrder.idioma,
            tipoMaestro: newOrder.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updatePropertyType ({ rootState, dispatch }, newOrder) {
      return new Promise((resolve, reject) => {
        api.post('propertyType/updatePropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: newOrder.id,
            code: newOrder.code,
            name: newOrder.name,
            idioma: newOrder.idioma,
            tipoMaestro: newOrder.tipoMaestro
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve()
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    delPropertyType ({ rootState, dispatch }, orderId) {
      return new Promise((resolve, reject) => {
        api.post('PropertyType/delPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: orderId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarPropertyTypesAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('PropertyType/comprobarPropertyTypesAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    addRoomProperties ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('roomPropertyType/addRoomPropertyTypes', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateRoomProperties ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('roomPropertyType/updateRoomPropertyTypes', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarRoomPropertiesTypeAsignado ({ rootState, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('roomPropertyType/comprobarRoomPropertiesTypeAsignado', {
          credentials: rootState.login.credentials,
          id
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          resolve(response.data.result)
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    delRoomPropertyTypes ({ rootState, dispatch }, roomPropId) {
      return new Promise((resolve, reject) => {
        api.post('roomPropertyType/delRoomPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: roomPropId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateIncidenceStatus ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('incidence/updateIncidenceStatus', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateIncidenceType ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('incidence/updateIncidenceType', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getAllRoomPropertyTypes ({ commit, rootState, dispatch }) {
      api.post('roomPropertyType/getAllRoomPropertyTypes', {
        credentials: rootState.login.credentials,
        values: {}
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setAllRoomPropTypes', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    getPropertiesByStringAndPropertyDevId ({ rootState, commit, dispatch }, propDevId) {
      const usuarioLocal = [JSON.parse(localStorage.usuario)]
      let entornos = []
      let promociones = {}
      usuarioLocal.map(e => {
        entornos = e.entornos
      })
      entornos.map(entorno => {
        const idubapi = entorno.idubapi
        const promos = entorno.promociones
        promociones[idubapi] = promos
      })
      return new Promise((resolve, reject) => {
        api.post('property/getPropertiesByStringAndPropertyDevId', {
          credentials: rootState.login.credentials,
          values: {
            propertyString: 'null',
            propertyDevelopmentId: propDevId,
            promociones
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setPropertiesByStringAndPropDevId', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    getPropertiesByIdPromotion ({ rootState, commit, dispatch }, propDevId) {
      return new Promise((resolve, reject) => {
        api.post('property/getPropertiesByStringAndPropertyDevId', {
          credentials: rootState.login.credentials,
          values: {
            propertyString: 'null',
            propertyDevelopmentId: propDevId,  
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setPropertiesByStringAndPropDevId', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    getInmueblesEspecialesByStringAndIdPromocion ({ rootState, commit, dispatch }, propDevId) {
      const usuarioLocal = [JSON.parse(localStorage.usuario)]
      let entornos = []
      let promociones = {}
      usuarioLocal.map(e => {
        entornos = e.entornos
      })
      entornos.map(entorno => {
        const idubapi = entorno.idubapi
        const promos = entorno.promociones
        promociones[idubapi] = promos
      })

      api.post('property/getInmueblesEspecialesByStringAndIdPromocion', {
        credentials: rootState.login.credentials,
        values: {
          propertyString: 'null',
          propertyDevelopmentId: propDevId,
          promociones
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setInmueblesEspecialesByStringAndIdPromocion', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    getLastLogIncidence ({ rootState, commit, dispatch }, incidenceId) {
      api.post('incidence/getLastLogIncidence', {
        credentials: rootState.login.credentials,
        values: {
          incidenceId: incidenceId
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setLastLogIncidence', response.data)
        })
        .catch(e => {
          return e
        })
    },
    getLogIncidence ({ rootState, commit, dispatch }, incidenceId) {
      api.post('incidence/getLogIncidence', {
        credentials: rootState.login.credentials,
        values: {
          incidenceId: incidenceId
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setHistoryStatus', response.data)
        })
        .catch(e => {
          return e
        })
    },
    getTiposParte ({commit, rootState, dispatch }) {
      api.post('workOrder/getWorkOrderModels', {
        credentials: rootState.login.credentials,
        values: {

        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setTiposParte', response.data)
        })
        .catch(e => {
          return e
        })
    },
    realizarEnvioParte ({ rootState}, payload) {
      return new Promise((resolve) => {
        api.post('workOrder/sendEmail', {
          credentials: rootState.login.credentials,
          values: {
            adjuntarFotos: payload.adjuntarFotos,
            adjuntarFotosVisita: payload.adjuntarFotosVisita,
            diferentesInmuebles: payload.diferentesInmuebles,
            diferentesPromociones: payload.diferentesPromociones,
            incidenceId: payload.ids,
            email_usuario: rootState.login.email,
            workOrderModelId: payload.parteSeleccionado,
            observacionesParte: payload.observaciones
          }
        })
          .then((response) => {
            if(response.data.filePath && response.data.filePath != '') {
              window.open(response.config.baseURL + response.data.filePath, '_blank');
            }
            resolve()
          })
          .catch(e => {
            return e
          })
      })
    },
    getComplaintTypesByIncidence ({ rootState, commit, dispatch }, id) {
      return new Promise((resolve) => {
        api.post('complaintType/getComplaintTypesByIncidence', {
          credentials: rootState.login.credentials,
          values: {
            incidenceId: id
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setComplaintTypesByIncidence', response.data.data)
            resolve()
          })
          .catch(e => {
            return e
          })
      })
    },
    getImgFirma ({ rootState, commit, dispatch }, values) {
      commit('setSourceGetSmallPicturesFirma', CancelToken.source())
      api.post('picture/getSmallPictures', {
        credentials: rootState.login.credentials,
        values
      }, {
        cancelToken: this.state.incidencias.sourceGetSmallPicturesFirma.token
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setImgFirma', response.data)
        })
        .catch(e => {
          return e
        })
    },
    cleanPreviewDocuments({ commit }) {
      commit('setAperturaPictures', [])
      commit('setCierrePictures', [])
      commit('setDocumentPictures', [])
      commit('setDocumentPicturesVisit', [])
      
    },
    getSmallPicturesApertura ({ rootState, commit }, values) {
      commit('setSourceGetSmallPicturesApertura', CancelToken.source())
      return new Promise((resolve, reject) => {
        api.post('picture/getSmallPictures', {
          credentials: rootState.login.credentials,
          values
        }, {
          cancelToken: this.state.incidencias.sourceGetSmallPicturesApertura.token
        })
          .then(response => {
            commit('setAperturaPictures', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
        })
    },
    getSmallPicturesCierre ({ rootState, commit, dispatch }, values) {
      commit('setSourceGetSmallPicturesCierre', CancelToken.source())
      return new Promise((resolve, reject) => {
        api.post('picture/getSmallPictures', {
          credentials: rootState.login.credentials,
          values
        }, {
          cancelToken: this.state.incidencias.sourceGetSmallPicturesCierre.token
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setCierrePictures', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
        })
    },
    getSmallPicturesCierreFirma ({ rootState, commit, dispatch }, values) {
      commit('setSourceGetSmallPicturesCierreFirma', CancelToken.source())
      api.post('picture/getSmallPictures', {
        credentials: rootState.login.credentials,
        values
      }, {
        cancelToken: this.state.incidencias.sourceGetSmallPicturesCierreFirma.token
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setCierrePicturesFirma', response.data)
        })
        .catch(e => {
          return e
        })
    },
    getDocumentosResumen ({ rootState, commit }, values) {
      api.post('/document/getDocuments/', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          commit('setDocumentosResumen', response.data)
        })
        .catch(e => {
          return e
        })
    },
    getDocuments ({ rootState, commit, dispatch }, values) {
      return new Promise((resolve, reject) => {
          commit('setSourceGetDocuments', CancelToken.source())
        api.post('/document/getDocuments/', {
          credentials: rootState.login.credentials,
          values
        },{
          cancelToken: this.state.incidencias.sourceGetDocuments.token
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setDocumentPictures', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getDocumentsVisit ({ rootState, commit, dispatch }, values) {
      return new Promise((resolve, reject) => {
          commit('setSourceGetDocuments', CancelToken.source())
        api.post('/document/getDocuments/', {
          credentials: rootState.login.credentials,
          values
        },{
          cancelToken: this.state.incidencias.sourceGetDocuments.token
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setDocumentPicturesVisit', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getDocumentsById ({ rootState, commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('document/getDocumentById', {
          credentials: rootState.login.credentials,
          values: {
            id: id
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setSingleDoc', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
        })
    },
    addPicture ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('picture/addPicture', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addDocument ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('document/addDocument', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    delPicture ({ rootState, dispatch }, {id, incidenceId}) {
      return new Promise((resolve, reject) => {
        api.post('picture/delPicture', {
          credentials: rootState.login.credentials,
          values: {
            id,
            incidenceId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    delDocument ({ rootState, dispatch }, {id, incidenceId}) {
      return new Promise((resolve, reject) => {
        api.post('document/delDocument', {
          credentials: rootState.login.credentials,
          values: {
            id,
            incidenceId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    realizarImportacion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }

        credenciales.tiposDeVisita = idubapi.PERMISOS_ACTOR_VISITAS_PV || null
        
        credenciales.promociones = promociones
        api.post('incidence/importarIncidencias', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    validarImportacionDocumentos ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }

        credenciales.tiposDeVisita = idubapi.PERMISOS_ACTOR_VISITAS_PV || null
        
        credenciales.promociones = promociones
        api.post('document/validateDocumentImport', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    importarDocumentos ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }

        credenciales.tiposDeVisita = idubapi.PERMISOS_ACTOR_VISITAS_PV || null
        
        credenciales.promociones = promociones
        api.post('document/importDocuments', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getHistorico ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('document/getHistorico', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteHistorico ({ rootState }, values) {
      return new Promise((resolve, reject) => {
        api.post('document/deleteHistorico', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addVisit ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('visit/addVisit', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setIdVisitaCliente', response.data.result)
            commit('setActualVisitId', response.data.result)
            resolve(response.data.result)
            // quitamos esto para que no pase la incidencia de mostrar datos de otra visita en la visita en curso. SIEMPRE TENEMOS UQE BUSCAR INCIDENCIAS DE LA VISITA POR EL ID Y NUNCA POR LA REFERENCIA!!
            /*api.post('visit/obtenerRefenciaVisita', {
              visitId: response.data.result,
              credentials: rootState.login.credentials
            })
              .then(response => {
                commit('setActualVisitId', response.data.result)
                resolve(response.data.result)
              }).
              catch(e => {
                reject(e)
                return e
              })

              */

            // return response
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    getVisit ({ rootState, commit, dispatch }, visitId) {
      api.post('/visit/getVisit/', {
        credentials: rootState.login.credentials,
        values: {
          visitId: visitId
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setActualVisit', response.data.data)
        })
        .catch(e => {
          return e
        })
    },
    updateVisit ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('visit/updateVisit', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addIncidence ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('incidence/addIncidence', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.result === 'NOK') {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            } else {
              commit('setNewIncidenceId', response.data.idIncidencia)
              resolve(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerPDF ({rootState, dispatch}, valores) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }

        const usuarioJson = JSON.parse(localStorage.getItem('usuario'))
        const idioma = usuarioJson.idioma
        credenciales.idioma = idioma
        credenciales.promociones = promociones
        console.log(valores)
        api.post('informes/getFichaFirmaPdf', {
          credentials: credenciales,
          values: {
            tipo: valores.tipo,
            identifiersList: valores.ids,
            adjuntarFotos: valores.adjuntarFotos,
            adjuntarFotosCierre: valores.adjuntarFotosCierre,
            maxInciFicha: valores.maxIncisPDF
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    realizarEnvioResumen ({rootState, dispatch}, {visitId, supervisores, idioma}) {
      return new Promise((resolve, reject) => {
        api.post('summary/sendEmail', {
          credentials: rootState.login.credentials,
          values: {
            visitId: visitId,
            supervisores: supervisores,
            idioma: idioma
          }
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getMensajesEstados ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('mensajesEstados/getMensajesEstados', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setMensajesEstados', response.data.data.mensajesEstados)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarMensajesEstados ({rootState, dispatch}, values) {
      return new Promise((resolve, reject) => {
        api.post('mensajesEstados/guardarMensajesEstados', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data.result === 'OK') {
              resolve(response)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getClientes ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('informes/getCustomers', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setCustomers', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerClientesPorPromocionInmueble ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('informes/obtenerClientesPorPromocionInmueble', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setClientesPorPromocionInmueble', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    cierreAutomaticoIncidencias ({rootState, dispatch}) {
      return new Promise((resolve, reject) => {
        api.post('incidence/cierreAutomatico', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    checkAccesoUsuario ({ commit }) {
      /*const usuarioJson = JSON.parse(localStorage.getItem('usuario'))
      const idubapi = JSON.parse(localStorage.getItem('idubapi'))
      const credentials = {
        id_actor: usuarioJson.id,
        token_sesion: usuarioJson.token,
        idubapi: idubapi.idubapi,
        origen: "WEB",
        flagPswEncript: false
      }*/
      return new Promise((resolve) => {
        commit('setTieneAcceso', true)
        resolve()
        /*
        let valuesCustom = {}
        if (usuarioJson.roles[0] === 'PV_CLIENTE') {
          valuesCustom = {
            idIncidencia: idIncidencia.idIncidencia,
            rolCliente: true
          }
        } else {
          valuesCustom = {
            idIncidencia: idIncidencia.idIncidencia,
            tiposSolicitudesDisponibles:['1', '2', '3', '4']
          }
        }
        api.post('incidence/comprobarAccesoIncidencia', {
          credentials,
          values: valuesCustom
        })
          .then(response => {
            commit('setTieneAcceso', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
          */
      })
    },
    setFiltros ({commit, rootGetters}, payload) {
      let filtrosStorage = {...payload, actorId: rootGetters['login/usuario'].id}
      localStorage.setItem('filtros', JSON.stringify(filtrosStorage))
      commit('setFiltros', filtrosStorage)
    },
    realizarImportacionInmueblesEspeciales ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('specialPropertyType/importarInmueblesEspeciales', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    realizarImportacionClientesEspeciales ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('SpecialCustomer/importaClientesEspeciales', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerPromocionesProveedor ({dispatch, rootState}) {
      // obtenemos las promociones en las que el proveedor tiene incidencias asociadas
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        api.post('/incidence/obtenerPromocionesProveedor', {
          credentials: credenciales
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerInmueblesProveedor ({dispatch, rootState}, values) {
      // obtenemos las promociones en las que el proveedor tiene incidencias asociadas
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        api.post('/incidence/obtenerInmueblesProveedor', {
          credentials: credenciales,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getPendingMessages ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('chat/getPendingMessages', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setPendingMessages', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

  },
  getters: {
    getDocumentosResumen (state) {
      return state.documentosResumen
    },
    // eslint-disable-next-line
    getFilters (state, getters, rootState, rootGetters) {
      let filtrosStorage = JSON.parse(localStorage.getItem('filtros'))
      if (filtrosStorage != null) {
        if (filtrosStorage.actorId === rootGetters['login/usuario'].id) {
          return state.filtros
        }
        return filtrosStorage
      }
      let filtros = {...state.filtros}
      filtros.status = state.estadosFiltroInicial
      return filtros
    },
    getFiltrosCliente (state) {
      return state.filtrosCliente
    },
    getProvidersByPropDevAndProf (state) {
      return state.providersByPropDevAndProf
    },
    getLocations (state) {
      return state.localizaciones
    },
    getStatusTypes (state) {
      return state.estados
    },
    getAll (state) {
      return state.listaIncidencias
    },
    getById (state) {
      return state.datosIncidencia
    },
    getUrgencias (state) {
      // return state.urgencias.map(function (a) { return { value: a.id, text: a.name } })
      return Object.keys(state.urgencias).map((key) => {
        return {
          value: state.urgencias[key].id,
          text: state.urgencias[key].name,
          code: state.urgencias[key].code,
          translates: state.urgencias[key].translates
        }
      })
    },
    getOficios (state) {
      // return state.oficios.map(function (a) { return { value: a.id, text: a.name } })
      return Object.keys(state.oficios).map((key) => {
        return {
          value: state.oficios[key].id,
          text: state.oficios[key].name,
          code: state.oficios[key].code,
          translates: state.oficios[key].translates
        }
      })
    },
    getSuboficios (state) {
      // return state.suboficios.map(function (a) { return { value: a.id, text: a.name } })
      return Object.keys(state.suboficios).map((key) => {
        return {
          code: state.suboficios[key].code,
          value: state.suboficios[key].id,
          text: state.suboficios[key].name,
          translates: state.suboficios[key].translates
        }
      })
    },
    getPredefinedIncidencesByProfession (state) {
      return state.predefInciByProf
    },
    getComplaintTypes (state) {
      return state.complaintTypes
    },
    getComplaintTypesByIncidence (state) {
      return Object.keys(state.complaintByIncidence).map(x => {
        return {
          id: state.complaintByIncidence[x].tipoReclamacionId
        }
      })
    },
    getComplaintTypesByIncidenceComplete (state) {
      return state.complaintByIncidence
    },
    getOrderTypes (state) {
      return state.orderTypes
    },
    getResponsables (state) {
      return state.responsables
    },
    getVisita (state) {
      return state.actualVisit
    },
    getIncidenceFromListNumber (state) {
      return state.incidenciasByVisita
    },
    getIncidenciasOrdenadas (state) {
      const lista = [...state.listaIncidencias]
      return lista.sort((a, b) => {
        if (parseInt(a.id) > parseInt(b.id)) { return -1 }
        if (parseInt(a.id) < parseInt(b.id)) { return 1 }
        return 0
      })
    },
    getTiposVisita (state) {
      return state.tipoVisita
    },
    getIdubapi (state, getters, rootState) {
      return rootState.login.idubapi
    },
    getPromocionesIdubapi (state, getters) {
      const idubapi = getters.getIdubapi
      return {
        [idubapi.idubapi]: idubapi.promociones
      }
    },
    getPropertiesDevelopmentIdubapi (state, getters) {
      const idubapi = getters.getIdubapi
      return {
        [idubapi.idubapi]: getters.getPropertiesDevelopment
      }
    },
    getPropertiesDevelopment (state) {
      return state.promociones
    },
    getTiposParte (state) {
      return state.tiposParte
    },
    getClientesEspecialesPromocionByIdPromocion (state) {
      return state.clientesEspPorIdPromo
    },
    getMensajesEstados (state) {
      return state.mensajesEstados
    },
    getNewVisitId (state) {
      return state.actualVisitId
    },
    getNewIncidenceId (state) {
      return state.newIncidenceId
    },
    getCierrePicturesFirma (state) {
      return state.cierreFirmaPictures
    },
    getIdVisitaCliente (state) {
      return state.idVisitaCliente
    },
    getVisitaModificada (state) {
      return state.visitaModificada
    }
  }
}
